import {
    createBrowserHistory
} from 'history';

export default class History {
    static history = createBrowserHistory();
}


// WEBPACK FOOTER //
// ./src/logic/utils/history.js